import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert } from "react-bootstrap";
import "./verifyEmailPage-styles.css";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";

const VerifyEmailPage = () => {
  const [successFullLogin, setSuccessFullLogin] = useState(false);
  const [userAlreadyVerified, setUserAlreadyVerified] = useState(false);
  const [somethingWentWrong, setsomethingWentWrong] = useState(false);
  let navigate = useNavigate();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const token = searchParams.get("token");
  console.log("Token", token);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await fetch(
      process.env.REACT_APP_VERIFY_EMAIL + "?token=" + token,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          /* Authorization: `Bearer ${token}`, */
        },
      }
    );
    if (response.status === 201) {
      console.log(response.status);
      const data = await response.json();
      console.log(data);
      console.log("Data Length", data.length);

      if (data._id.length > 0) {
        setSuccessFullLogin(true);
        setTimeout(() => {
          navigate("/");
        }, "3000");
      } else {
        console.log("User Already verified");
      }
    } else if (response.status === 204) {
      console.log(response.status);
      setUserAlreadyVerified(true);
      setTimeout(() => {
        navigate("/");
      }, "3000");
    } else {
      console.log(response.status);
      setsomethingWentWrong(true);
    }
  };

  return (
    <Container fluid>
      <Helmet>
        <style>
          {
            "body { background: linear-gradient(180deg, #264068 100%, #50678b 100%) }"
          }
        </style>
      </Helmet>
      <Row>
        <Col>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            {successFullLogin && (
              <Alert className="alert-for-verify-email-page" variant="success">
                Your email has been verified! You are now being redirected to
                the login page.
              </Alert>
            )}
            {userAlreadyVerified && (
              <Alert variant="primary" className="alert-for-verify-email-page">
                Your email has already been verified. We will now redirect you
                to the login page.
              </Alert>
            )}
            {somethingWentWrong && (
              <Alert variant="danger" className="alert-for-verify-email-page">
                Something went wrong. Please contact us and we will help you
                out.
              </Alert>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyEmailPage;
